import z from "zod";

export const CloudProviderSchema = z.enum(["aws", "gcp", "azure"]);

/** Cloudflare placement identifier, published as-is (`docs/discuss/002`). */
export const PlacementRegionSchema = z.string().regex(/^(aws|gcp|azure):[a-z0-9-]+$/);

export const PlacementRegionInfoSchema = z.strictObject({
    id: PlacementRegionSchema,
    provider: CloudProviderSchema,
    /** Measured, not declared — see docs/discuss/002. */
    colo: z.string(),
    location: z.string(),
});

export const RelayEndpointSchema = z.strictObject({
    id: z.string(),
    title: z.string(),
    region: PlacementRegionSchema,
    url: z.string(),
    state: z.string(),
    createdAt: z.number(),
});

/** Shared by the RPC contract and the cabinet form, so both validate identically. */
export const RelayCreateInputSchema = z.strictObject({
    title: z.string().min(1, "Укажите название").max(120),
    region: PlacementRegionSchema,
});

/** Creation is the only time the key is returned; afterwards only its hash exists. */
export const CreatedRelayEndpointSchema = RelayEndpointSchema.extend({
    key: z.string(),
    apiUrl: z.string(),
});

export type PlacementRegionInfo = z.output<typeof PlacementRegionInfoSchema>;
export type RelayEndpoint = z.output<typeof RelayEndpointSchema>;
